<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">business</v-icon>
			<v-toolbar-title>Dane projektu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Nazwa projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.title}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Numer projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.code}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Nazwa naboru</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.contestName}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Data wysłania projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.sendDate}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Status projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{projectStatusName}}
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {AgencyProject} from "../../../../api/generated/AgencyProject";

	export default {
		name: "AgencyProjectSummaryDataView",

		data () {
			return {
				project: null,
				dataLoaded: false
			};
		},

		created () {
			this.getProjectSummaryMainData();
		},

		computed: {
			projectStatusName() {
				switch (this.project.status) {
					case "NEW": return "Nowy wniosek";
					case "SUBMITTED": return "Wysłany";
					case "REJECTED": return "Odrzucony";
					case "AWAITING_CORRECTION": return "Oczekuje na poprawki";
					case "APPROVED": return "Realizowany";
					case "PROJECT_CHANGES_REQUESTED":
						return "Projekt oczekuje na poprawki";
					case "FINISHED": return "Zakończony";
					default: return "";
				}
			}
		},

		methods: {
			getProjectSummaryMainData () {
				AgencyProject.getSummaryMainData(this, this.$route.params.projectId, successResponse => {
						this.project = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych projektu", errorResponse);
					});
			}
		}
	};
</script>

<style scoped>

</style>